module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-settings-up@1x.png?0.0.53";